import { render, staticRenderFns } from "./UserDetailsTabs.vue?vue&type=template&id=0fb8896f&lang=html"
import script from "./UserDetailsTabs.vue?vue&type=script&lang=js"
export * from "./UserDetailsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports